(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recovr-comparison-vs"] && !Shopify.designMode) return;
  try {
    
  // Equalise row heights between the two halves per row index, so a long label
  // can never make the sticky row taller than its competitor twin. The
  // reference just hopes labels stay short; we sync on load + resize + editor.
  function cmpxSync(root) {
    var L = Array.prototype.slice.call(root.querySelectorAll('.cmpx-sticky .cmpx-row'));
    var R = Array.prototype.slice.call(root.querySelectorAll('.cmpx-scroll .cmpx-row'));
    L.forEach(function (l, i) {
      if (!R[i]) return;
      l.style.minHeight = R[i].style.minHeight = '';
      var h = Math.max(l.offsetHeight, R[i].offsetHeight) + 'px';
      l.style.minHeight = h;
      R[i].style.minHeight = h;
    });
  }
  function cmpxSyncAll() {
    document.querySelectorAll('.cmpx').forEach(cmpxSync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cmpxSyncAll);
  } else {
    cmpxSyncAll();
  }
  window.addEventListener('load', cmpxSyncAll);
  window.addEventListener('resize', cmpxSyncAll);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.cmpx').forEach(cmpxSync);
  });

  } catch(e) { console.error(e); }
})();
})();
